/**
 * ACP separates user-facing assistant output (`agent_message_chunk`) from internal
 * reasoning (`agent_thought_chunk`). Some agents/bridges also emit `thinking` or a
 * generic `update` kind for text — transcript merge/display must not concatenate
 * across these buckets.
 *
 * @see https://agentclientprotocol.com/protocol/schema — SessionUpdate variants
 */

export type AgentTextStreamBucket = 'message' | 'thought';

/**
 * Resolve which logical text stream a transcript row belongs to, using the persisted
 * row `kind` and optionally the inner `sessionUpdate` from the payload when the row
 * kind is ambiguous.
 */
export function resolveAgentTextStreamBucket(params: {
  transcriptRowKind: string;
  sessionUpdate?: string | undefined;
}): AgentTextStreamBucket | null {
  const k = params.transcriptRowKind;
  const su = params.sessionUpdate;
  if (
    k === 'agent_thought_chunk' ||
    su === 'agent_thought_chunk' ||
    k === 'thinking' ||
    su === 'thinking'
  ) {
    return 'thought';
  }
  if (
    k === 'agent_message_chunk' ||
    su === 'agent_message_chunk' ||
    k === 'update' ||
    su === 'update'
  ) {
    return 'message';
  }
  return null;
}
